<template>
  <v-app>

    <v-navigation-drawer
      class="navdrawer"
      app
      v-model="navDrawerDisplayed"
      right
      temporary
    >
    <router-link
      :disabled="$store.state.animationRunning"
      to="/" tag="button" class="navdrawerlink"
    >
      Főoldal
    </router-link>
    <router-link
      :disabled="$store.state.animationRunning"
      to="/sorobanbasics" tag="button" class="navdrawerlink"
    >
      Alapműveletek
    </router-link>
    <router-link
      :disabled="$store.state.animationRunning"
      to="/practice" tag="button" class="navdrawerlink"
    >
      Gyakorló
    </router-link>
    <router-link
      :disabled="$store.state.animationRunning"
      to="/kids" tag="button" class="navdrawerlink pink--text text--darken-2"
    >
      KIDS
    </router-link>




    </v-navigation-drawer>

    <v-app-bar app color="transparent" hide-on-scroll>
      <router-link :disabled="$store.state.animationRunning" to="/" exact tag="button" class="navlink">
        <span class="sorobanlogo">Soroban</span>
      </router-link>

      <router-link
        :disabled="$store.state.animationRunning"
        to="/kids" tag="button" class="navlink"
      >
        <div class="kids">
          <span class="indigo--text">K</span>
          <span class="red--text">I</span>
          <span class="green--text">D</span>
          <span class="orange--text">S</span>
        </div>
      </router-link>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        @click="navDrawerDisplayed=!navDrawerDisplayed"
      ></v-app-bar-nav-icon>
    </v-app-bar>


    <v-content>
      <v-container fluid>
        <transition name="fade" mode='out-in' appear>
          <router-view></router-view>
        </transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data(){
    return{
      navDrawerDisplayed: true,
    }
  },
};
</script>

<style lang="scss">
  @import 'styles/global.scss';
  #app{
    background-color: #F3E5F5;
  }

  .container > div{
    max-width:1500px;
    margin-left: auto;
    margin-right: auto;
  }
  .navlink{
    font-size: 1.5rem;
    transform: scale(0.9);
    transition: all 0.5s ease;
    outline: none;


    &:hover:not(.router-link-active){
      transform: scale(1);
      transition: all 0.5s ease;
      cursor: pointer;
    }

    .kids{
      font-family: 'Patrick Hand', cursive;
      font-weight: bold;
      border-radius: 50%;
      background: lightpink;
      padding: 10px;
      margin-left: 20px;
    }
  }

  .navdrawer{
    background: linear-gradient(to bottom, lightblue, #F3E5F5);

    .v-navigation-drawer__content{
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;

      button{
        outline: none;
        margin-top: 15px;
        padding: 5px;

        &.router-link-exact-active{
          background-color: dodgerblue;
        }
      }
    }
  }
</style>
